import React, { useEffect, useMemo, useState } from "react";
import { MagnifyingGlass } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import { loadAntiGaspiProducts } from "../../data/antiGaspi";
import { addProductToCart, getSuggestedCartAmount } from "../../data/cart";

function AntiGaspi() {
  const navigate = useNavigate();
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [products, setProducts] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState("Toutes");

  useEffect(() => {
    let isMounted = true;
    const fetchProducts = async () => {
      const loaded = await loadAntiGaspiProducts();
      if (!isMounted) return;
      setProducts(loaded);
      setTimeout(() => {
        if (isMounted) setLoaderStatus(false);
      }, 600);
    };
    fetchProducts();
    return () => {
      isMounted = false;
    };
  }, []);

  const categories = useMemo(
    () => ["Toutes", ...Array.from(new Set(products.flatMap((p) => Array.isArray(p.category) ? p.category : [p.category].filter(Boolean))))],
    [products]
  );

  const filtered = useMemo(() => {
    return products.filter((p) => {
      const cats = Array.isArray(p.category) ? p.category : [p.category];
      return categoryFilter === "Toutes" || cats.includes(categoryFilter);
    });
  }, [products, categoryFilter]);

  const handleAddToCart = async (product) => {
    try {
      await addProductToCart(product, getSuggestedCartAmount(product));
      navigate("/ShopCart");
    } catch (error) {
      window.alert(error.message);
    }
  };

  return (
    <div className="container py-4">
      {loaderStatus ? (
        <div className="loader-container">
          <MagnifyingGlass visible={true} height="100" width="100" ariaLabel="loading" glassColor="#c0efff" color="#198754" />
        </div>
      ) : (
        <>
          <div className="card bg-success bg-opacity-10 border-0 mb-4">
            <div className="card-body p-4">
              <h1 className="mb-2">🌿 Anti-gaspi</h1>
              <p className="mb-0 text-muted">
                Des produits à date courte ou à l'emballage abîmé, vendus à prix réduits (-15%, -25%, -40%...)
                pour éviter le gaspillage. À consommer rapidement !
              </p>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <p className="mb-0">
              <span className="text-dark fw-bold">{filtered.length}</span> produit(s) anti-gaspi
            </p>
            <select
              className="form-select w-auto"
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
              aria-label="Filtrer par catégorie"
            >
              {categories.map((c) => (
                <option key={c} value={c}>{c === "Toutes" ? "Toutes les catégories" : c}</option>
              ))}
            </select>
          </div>

          {!filtered.length ? (
            <div className="alert alert-light border">Aucun produit anti-gaspi en ce moment.</div>
          ) : (
            <div className="row g-4 row-cols-xl-4 row-cols-lg-3 row-cols-2">
              {filtered.map((product) => (
                <div className="col" key={product.id}>
                  <div className="card card-product h-100">
                    <div className="card-body">
                      <div className="text-center position-relative">
                        <div className="position-absolute top-0 start-0">
                          <span className="badge bg-success">-{product.antiGaspiDiscount}%</span>
                        </div>
                        <Link to="/SingleShop">
                          <img src={product.image} alt={product.name} className="mb-3 img-fluid" />
                        </Link>
                      </div>
                      <div className="text-small mb-1 text-muted">
                        <small>{product.category}</small>
                      </div>
                      <h2 className="fs-6">
                        <Link to="/SingleShop" className="text-inherit text-decoration-none">{product.name}</Link>
                      </h2>
                      <small className="text-success d-block mb-1">{product.antiGaspiReason}</small>
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <div>
                          <span className="text-muted text-decoration-line-through me-2">{product.originalPriceLabel}</span>
                          <span className="fs-5 fw-bold text-dark">{product.antiGaspiPriceLabel}</span>
                        </div>
                        <button type="button" className="btn btn-success btn-sm" onClick={() => handleAddToCart(product)}>
                          Ajouter
                        </button>
                      </div>
                      <small className="d-block mt-2 text-muted">Stock: {product.stock}</small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default AntiGaspi;
